<template>
  <div class="my-space-card my-space-card--scrollable" :class="{ 'my-space-card--mobile-collapsed': collapsed && !expanded, 'my-space-card--expanded': expanded }" :role="expanded ? 'dialog' : null" :aria-modal="expanded ? 'true' : null" tabindex="-1" @keydown.esc="expanded = false">
    <div v-if="expanded" class="my-space-card-modal-backdrop" aria-hidden="true" @click="expanded = false"></div>
    <div class="my-space-card-header">
      <span class="my-space-card-title"><span class="my-space-card-icon my-space-priority-tasks__header-icon"><AppIcon name="account_tree" /></span>Mis prioridades por contexto</span>
      <button type="button" class="my-space-card-refresh" :disabled="loading || refreshing" title="Actualizar tareas prioritarias" @click.stop="refresh"><AppIcon name="refresh" :class="{ 'my-space-card-refresh__icon--spinning': refreshing }" /></button>
      <button type="button" class="my-space-card-expand" :aria-expanded="String(expanded)" :title="expanded ? 'Cerrar' : 'Abrir vista ampliada'" @click.stop="expanded = !expanded"><AppIcon :name="expanded ? 'close' : 'open_in_full'" /></button>
      <button v-if="!expanded" type="button" class="my-space-card-collapse" :aria-expanded="String(!collapsed)" @click="collapsed = !collapsed"><AppIcon :name="collapsed ? 'expand_more' : 'expand_less'" /></button>
    </div>
    <div class="my-space-card-body">
      <div v-if="loading" class="my-space-card-loading"><b-spinner small /></div>
      <template v-else>
        <details v-for="group in groups" :key="group.key" class="my-space-task-tree my-space-priority-tasks__group" :class="{ 'my-space-priority-tasks__group--urgent': group.hasUrgent }">
          <summary class="my-space-task-tree__summary">
            <span class="my-space-task-tree__group"><AppIcon :name="group.icon" /><span class="my-space-task-tree__group-copy"><span class="my-space-task-tree__group-name">{{ group.name }}</span><span class="my-space-priority-tasks__type">{{ group.type }}</span></span></span>
            <span class="my-space-task-tree__meta"><b-badge class="my-space-task-tree__count">{{ group.tasks.length }}</b-badge><AppIcon name="expand_more" class="my-space-task-tree__chevron" /></span>
          </summary>
          <div class="my-space-task-tree__children">
            <div v-for="item in group.tasks" :key="item.id" class="my-space-task-tree__task my-space-priority-tasks__task">
              <AppIcon name="subdirectory_arrow_right" class="my-space-task-tree__task-icon" />
              <span class="my-space-priority-tasks__task-copy">
                <span class="my-space-day-item-text">#{{ item.id }} · {{ item.title }}</span><AppIcon v-if="item.reminder" name="notifications" class="my-space-priority-tasks__reminder" v-b-tooltip.hover :title="reminderLabel(item.reminder)" />
                <span v-if="item.assigned" class="my-space-priority-tasks__assignee">
                  <b-avatar v-if="item.assigned.image" :src="item.assigned.image" size="20px" />
                  <b-avatar v-else size="20px" :text="avatarFromName(item.assigned.name).text" :style="avatarFromName(item.assigned.name).style" />
                  {{ staffName(item.assigned) }}
                </span>
              </span>
              <TaskChecklistProgress :progress="item.checklist_progress" :status="item.checklist_status" />
              <span class="my-space-priority-tasks__priority" :class="'my-space-priority-tasks__priority--' + item.priority">{{ priorityLabel(item.priority) }}</span>
              <router-link class="my-space-priority-tasks__go" :to="taskRoute(item)" :title="'Ver #' + item.id + ' · ' + item.title" :aria-label="'Ver detalle de #' + item.id + ' · ' + item.title"><AppIcon name="arrow_forward" /></router-link>
            </div>
          </div>
        </details>
        <EmptyState v-if="!groups.length" icon="priority_high" title="No hay tareas prioritarias" description="No tenés tareas pendientes de prioridad alta o urgente." />
      </template>
    </div>
  </div>
</template>

<script>
import serviceTasks from '../staff/services'
import ErrorToken from '@/handler/errorToken'
import Funciones from '@/handler/funciones'
import Session from '@/handler/session'
import { EventBus } from '@/handler/event-bus'
import TaskChecklistProgress from './TaskChecklistProgress'
import moment from 'moment'

export default {
  name: 'MySpacePriorityTasksWidget',
  components: { TaskChecklistProgress },
  data: () => ({ loading: true, refreshing: false, collapsed: window.innerWidth <= 767, expanded: false, tasks: [] }),
  computed: {
    groups() {
      var groups = {}
      this.tasks.forEach((item) => {
        var relation = this.relationFor(item)
        if (!relation) return
        var key = relation.type + '-' + relation.id
        if (!groups[key]) groups[key] = { key, name: relation.name, type: relation.label, icon: relation.icon, hasUrgent: false, urgentCount: 0, highCount: 0, tasks: [] }
        groups[key].tasks.push(item)
        groups[key].hasUrgent = groups[key].hasUrgent || item.priority === 'urgent'
        if (item.priority === 'urgent') groups[key].urgentCount += 1
        if (item.priority === 'high') groups[key].highCount += 1
      })
      return Object.keys(groups).map(key => groups[key]).sort((first, second) => {
        if (second.urgentCount !== first.urgentCount) return second.urgentCount - first.urgentCount
        if (second.highCount !== first.highCount) return second.highCount - first.highCount
        return second.tasks.length - first.tasks.length
      })
    },
  },
  mounted() { EventBus.$on('MySpace:tasks-refresh', this.refresh); this.load() },
  beforeDestroy() { EventBus.$off('MySpace:tasks-refresh', this.refresh) },
  methods: {
    load(refresh = false) {
      if (refresh) this.refreshing = true
      serviceTasks.obtenerTareas({ status: 'pending', exclude_permanent: true }).then((response) => {
        var items = Array.isArray(response.data) ? response.data : []
        var currentStaffId = this.currentStaffId()
        this.tasks = items.filter(item => Number(item.assigned_staff_id) === Number(currentStaffId) && ['urgent', 'high'].includes(item.priority) && this.relationFor(item))
        this.loading = false
        this.refreshing = false
      }).catch((error) => {
        this.loading = false
        this.refreshing = false
        this.$awn.alert(ErrorToken.valid(error))
      })
    },
    refresh() { if (!this.loading && !this.refreshing) this.load(true) },
    currentStaffId() {
      var session = Session.getSession()
      return session && session.auth && session.auth.user ? session.auth.user.selector_session : null
    },
    relationFor(item) {
      if (item.customer_id) return { type: 'customer', id: item.customer_id, name: (item.customer && item.customer.name) || 'Cliente #' + item.customer_id, label: 'Cliente', icon: 'business' }
      if (item.supplier_id) return { type: 'supplier', id: item.supplier_id, name: (item.supplier && item.supplier.name) || 'Proveedor #' + item.supplier_id, label: 'Proveedor', icon: 'local_shipping' }
      if (item.project_id) return { type: 'project', id: item.project_id, name: (item.project && item.project.name) || 'Proyecto #' + item.project_id, label: 'Proyecto', icon: 'folder' }
      return null
    },
    taskRoute(item) {
      var relation = this.relationFor(item) || {}
      return { name: 'TasksStaffCrud', params: { taskId: item.id }, query: { widget_task_filter: String(Date.now()), relation_type: relation.type, relation_id: relation.id, assigned_staff_id: item.assigned_staff_id || '', priority: item.priority } }
    },
    staffName(staff) { return staff && staff.name ? staff.name : 'Sin asignar' },
    avatarFromName(name) { return Funciones.avatarFromName(name || '') },
    priorityLabel(priority) { return priority === 'urgent' ? 'Urgente' : 'Alta' },
    reminderLabel(reminder) { return 'Recordatorio: ' + moment(reminder.remind_at).format('DD/MM/YYYY HH:mm') },
  },
}
</script>

<style scoped>
.my-space-priority-tasks__header-icon { background: var(--app-color-primary); }
.my-space-priority-tasks__type, .my-space-priority-tasks__assignee { color: var(--app-color-text-muted); font-size: var(--app-text-xs); }
.my-space-priority-tasks__task-copy { display: flex; flex: 1; flex-direction: column; min-width: 0; }
.my-space-priority-tasks__task-copy .my-space-day-item-text { color: var(--app-color-text); font-weight: var(--app-font-bold); }
.my-space-priority-tasks__assignee { display: inline-flex; align-items: center; gap: 5px; margin-top: 2px; }
.my-space-priority-tasks__group--urgent .my-space-task-tree__summary { background: var(--app-color-danger-soft) !important; }
.my-space-priority-tasks__priority { margin-left: 8px; color: var(--app-color-warning); font-size: var(--app-text-xs); font-weight: var(--app-font-bold); }
.my-space-priority-tasks__priority--urgent { color: var(--app-color-danger); }
.my-space-priority-tasks__go { display: inline-flex; align-items: center; justify-content: center; width: 26px; height: 26px; margin-left: 8px; padding: 0; border: 0; border-radius: 50%; background: var(--app-color-primary-soft); color: var(--app-color-primary); }
.my-space-priority-tasks__go:hover { background: var(--app-color-primary); color: var(--app-color-on-primary); }
.my-space-priority-tasks__reminder { flex: 0 0 auto; color: var(--app-color-primary); font-size: 16px; }
</style>
